'use client'

import { useAuth } from '@/lib/auth/auth-context'
import { translations, type Locale, type TranslationKey } from './translations'

export function useTranslation() {
  const { profile } = useAuth()

  // Get locale from profile or fallback to 'it'
  const locale = (profile?.preferred_language as Locale) || 'it'

  const t = (key: TranslationKey): string => {
    return (translations as Record<string, Record<string, string>>)[locale]?.[key] || translations.it[key] || key
  }

  return { t, locale }
}
